import _ from 'lodash';
import { fork, put, take, takeLatest } from 'redux-saga/effects';

import {
    ADD_PERSON,
    PERSON_FORM_SUBMIT,
    PERSON_FORM_SUBMIT_PENDING,
    PERSON_FORM_SUBMIT_COMPLETED,
    ADDRESS_FETCH_REQUESTED,
    ADDRESS_FETCH_REQUESTED_PENDING,
    ADDRESS_FETCH_REQUESTED_SUCCESS,
    EDIT_PERSON,
    EDITING_PERSON,
    DELETE_PERSON
} from './PersonModal.actions';
import { buildPeopleBody, removePerson } from './PersonModalHelper';
import { selectAPI } from '../../../api/API.sagas';
import {
    getPersonFromUID,
    serialisePerson
} from '../../../api/lendingAPI/CustomerStateAPIHelper';
import {
    API_GET_ADDRESS_LOOKUP,
    API_GET_ADDRESS_LOOKUP_SUCCESS,
    API_GET_CUSTOMER_STATE_EDIT,
    API_SAVE_CUSTOMER_STATE,
    API_SAVE_CUSTOMER_STATE_SUCCESS
} from '../../../api/lendingAPI/LendingAPI.actions';
import { CLOSE_MODAL, OPEN_MODAL } from '../../../iwModals/Modals.actions';

export const personModalSagasWorkers = [
    fork(addPerson),
    fork(editPerson),
    fork(deletePerson),
    fork(fetchAddresses)
];

function* addPerson() {
    yield takeLatest(ADD_PERSON, function* () {
        yield put({
            type: OPEN_MODAL,
            id: 'PersonModal'
        });

        const nextAction = yield take([PERSON_FORM_SUBMIT, CLOSE_MODAL]);

        switch (nextAction.type) {
            case PERSON_FORM_SUBMIT:
                yield submitPersonForm(nextAction.person);
                break;
            case CLOSE_MODAL:
                //TODO: decide how handle close on person modal form
                break;
        }
    });
}

function* submitPersonForm(person) {
    yield put({ type: PERSON_FORM_SUBMIT_PENDING });

    const { customer_state } = yield selectAPI();
    const people = customer_state?.application?.people;
    const previousPersonState = _.find(people, { uid: person.uid });
    const serialisedPerson = serialisePerson(previousPersonState, person);
    const peopleState = buildPeopleBody(people, serialisedPerson);

    yield saveFormAndClose(peopleState);
}

function* editPerson() {
    yield takeLatest(EDIT_PERSON, function* (action) {
        const { customer_state } = yield selectAPI();
        const person = getPersonFromUID(customer_state, action.uid);

        yield put({ type: EDITING_PERSON, person });

        yield put({
            type: OPEN_MODAL,
            id: 'PersonModal'
        });

        const nextAction = yield take([PERSON_FORM_SUBMIT, CLOSE_MODAL]);

        switch (nextAction.type) {
            case PERSON_FORM_SUBMIT:
                yield submitPersonForm(nextAction.person);
                break;
            case CLOSE_MODAL:
                //TODO: decide how handle close on person modal form
                break;
        }
    });
}

function* deletePerson() {
    yield takeLatest(DELETE_PERSON, function* (action) {
        const { customer_state } = yield selectAPI();
        const people = customer_state?.application?.people;

        const peopleState = removePerson(people, action.uid);

        yield saveFormAndClose(peopleState);
    });
}

function* fetchAddresses() {
    yield takeLatest(ADDRESS_FETCH_REQUESTED, function* (action) {
        yield put({ type: ADDRESS_FETCH_REQUESTED_PENDING });

        yield put({ type: API_GET_ADDRESS_LOOKUP, postcode: action.postcode });

        yield take(API_GET_ADDRESS_LOOKUP_SUCCESS);

        const { address_lookup } = yield selectAPI();
        yield put({
            type: ADDRESS_FETCH_REQUESTED_SUCCESS,
            addresses: address_lookup
        });
    });
}

function* saveFormAndClose(people) {
    yield put({
        type: API_GET_CUSTOMER_STATE_EDIT,
        data: {
            application: {
                people: people
            }
        }
    });

    yield put({ type: API_SAVE_CUSTOMER_STATE });
    yield take(API_SAVE_CUSTOMER_STATE_SUCCESS);

    const { customer_state } = yield selectAPI();
    const latestPeople = customer_state?.application?.people;

    //TODO: this could go in between the put/get
    yield put({ type: PERSON_FORM_SUBMIT_COMPLETED, people: latestPeople });

    yield put({ type: CLOSE_MODAL });
}
